<template>
<v-app>
  <template>
    <div
      v-if="bannerMessage && bannerColour"
      class="sticky-banner"
      :style="'background-color: ' + bannerColour + '; color: ' + bannerTextColour + ';'"
    >
      <p>{{ bannerMessage }} <a v-if="bannerLink" :href="bannerLink" target=”_blank”>{{ bannerLinkText }}</a></p>
    </div>
    <div v-if="!hideNavigation">
      <NavigationDrawer />
      <AppBar />
      <v-divider class="background"></v-divider>
    </div>
    <v-main :class="hideNavigation ? 'white' : ''">
      <v-container fluid :class="containerClasses">
        <router-view></router-view>
      </v-container>
    </v-main>
  </template>
</v-app>
</template>

<script>
import AppBar from '@/components/structural/AppBar';
import NavigationDrawer from '@/components/structural/NavigationDrawer';
import { mapGetters } from "vuex";

export default {
  name: 'App',
  components: {
    AppBar,
    NavigationDrawer
  },
  data: () => ({
    bannerColour: null,
    bannerTextColour: null,
    bannerMessage: null,
    bannerLink: null,
    bannerLinkText: null
  }),
  mounted() {
    this.loadBannerJsonFile();
  },
  computed: {
    ...mapGetters(["isAdminUser", "getTenant"]),
    hideNavigation() {
      return this.$route.meta.hideNavigation || false;
    },
    containerClasses() {
      if (this.hideNavigation) {
        return 'fill-height pa-0';
      }
      return '';
    }
  },
  methods: {
    async loadBannerJsonFile() {
      try {
        const response = await fetch('/banner.json');
        if (response.ok) {
          let text = await response.text();
          let json = JSON.parse(text);
          this.bannerColour = json.colour;
          this.bannerTextColour = json.textColour;
          this.bannerMessage = json.message;
          this.bannerLink = json.link;
          this.bannerLinkText = json.linkText;
        } else {
          return;
        }
      } catch (error) {
        console.error("No banner json file found.");
      }
    }
  },
};
</script>
<style>
.sticky-banner {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
    height: 34px;
    padding-top: 8px;
    text-align: center;
    font-size: 12px;
    color: black;
    z-index: 1000; /* Ensure it stays on top of other content */
  }
</style>